import { render, staticRenderFns } from "./JSelectBanji.vue?vue&type=template&id=45c374b9&scoped=true"
import script from "./JSelectBanji.vue?vue&type=script&lang=js"
export * from "./JSelectBanji.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c374b9",
  null
  
)

export default component.exports